import {
  GetReferralTransactionsArgs,
  ReferralOverviewDto,
  ReferralTransactionsPageDto
} from 'booksprout'
import { gql } from '@apollo/client/core'
import { useApollo } from '../apollo/apolloModule'

/**
 * Replaces `ReferralsService`.
 *
 * Read-only and cache-hostile: both figures move underneath us (FirstPromoter approves rewards, the
 * cron and the checkout flows push credit into Stripe), so every call goes to the network rather
 * than serving a balance that was true a page ago.
 */

const getOverview = (): Promise<ReferralOverviewDto> => {
  return useApollo().query({
    query: gql`
      query ReferralOverview {
        referralOverview {
          referralLink,
          lifetimeReferrals,
          availableCreditCents,
          pendingCreditCents,
          lifetimeCreditCents
        }
      }
    `,
    fetchPolicy: 'network-only'
  })
}

const getTransactions = (args: GetReferralTransactionsArgs): Promise<ReferralTransactionsPageDto> => {
  return useApollo().query({
    variables: {
      ...args
    },
    query: gql`
      query ReferralTransactions (
        $page: Int,
        $limit: Int
      ) {
        referralTransactions (
          page: $page,
          limit: $limit
        ) {
          items {
            id,
            type,
            date,
            amountCents,
            balanceAfterCents,
            maskedEmail,
            description,
            isPending,
            availableDate
          },
          hasMore,
          nextPage
        }
      }
    `,
    fetchPolicy: 'network-only'
  })
}

/**
 * Just the spendable figure, for the checkout summary. Cheaper than the overview and, unlike it,
 * free of the lazy FirstPromoter enrolment - nobody should be enrolled by opening a payment page.
 */
const getAvailableCreditCents = (): Promise<number> => {
  return useApollo().query({
    query: gql`
      query ReferralAvailableCreditCents {
        referralAvailableCreditCents
      }
    `,
    fetchPolicy: 'network-only'
  })
}

const service = {
  getOverview,
  getTransactions,
  getAvailableCreditCents
}

export function referralsService () {
  return service
}
